"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppIdsArr = void 0;
var appIds_enum_1 = require("../enums/appIds.enum");
exports.AppIdsArr = [
    appIds_enum_1.EAppId.TE_CORE,
    appIds_enum_1.EAppId.TE_VIEWER,
    appIds_enum_1.EAppId.TE_RESERVE,
    appIds_enum_1.EAppId.TE_PLAN,
    appIds_enum_1.EAppId.TE_PREFERENCES,
    appIds_enum_1.EAppId.TE_EXAM,
    appIds_enum_1.EAppId.TE_REPORTING,
    appIds_enum_1.EAppId.TE_ADMIN,
];
